/* lua.js generated code 0.3.1 */

require("clover/gamePlay/CreateGameSceneLogic")
let StartBuildShipLevelLogic = xClass("StartBuildShipLevelLogic")

// StartBuildShipLevelLogic.checkCanStart = function () {
//     return [true]
//     let info = GoldMatchActivityManager.getInstance().getInfo()
//     let local = Localhost.time()
//     let activityEnd = local >= info.end
//     if (activityEnd) {
//         return [null, ZooErrorCode.TIME_MODE_ACTIVITY_END]
//     }
//     let hasTimes = info.leftTimes > 0
//     if (!hasTimes) {
//         return [null, ZooErrorCode.TIME_MODE_TIME_NOT_ENOUGT]
//     }
//     return [true]
// }
StartBuildShipLevelLogic.create = function (levelId, otherData) {
    let self = this
    // if (force) {
    //     return [StartBuildShipLevelLogic.new(levelId)]
    // }
    // let [success, errCode] = self.checkCanStart(levelId)
    // if (!success) {
    //     return [null, errCode]
    // }
    return [StartBuildShipLevelLogic.new(levelId, otherData)]
}
StartBuildShipLevelLogic.prototype.ctor = function (levelId, otherData) {
    let self = this
    self.initProps = table()
    self.levelId = levelId
    self.initProps = table()
    self.otherData = otherData
    UserLevel.getInstance().addLevelTypeEnum(GameLevelType.kBuildShip, require("activity/BuildShip/levelLogic/BuildShipUserLevelType.js"))
}
StartBuildShipLevelLogic.prototype.initLevelLogics = function () {
    require.ensure([], () => {
        require("clover/scene/GameScene")
        require("clover/scene/GameSceneUI")
        FailLevelLogicClassTypeRef[GameLevelType.kBuildShip] = require("activity/BuildShip/levelLogic/FailBuildShipLevelLogic")
        PassLevelLogicClassTypeRef[GameLevelType.kBuildShip] = require("activity/BuildShip/levelLogic/PassBuildShipLevelLogic")
        QuitLevelLogicClassTypeRef[GameLevelType.kBuildShip] = require("activity/BuildShip/levelLogic/QuitBuildShipLevelLogic")
        // GameReviveLogicClassTypeRef[GameLevelType.kBuildShip] = require("activity/BuildShip/levelLogic/BuildShipReviveLogic")
    }, null, 'game')
}
// StartBuildShipLevelLogic.prototype.levelInfo = function () {
//     let self = this
//     let ret = table([1, "gameplayMode", LevelConfigManager.getInstance().getLevelGameMode(self.levelId)])
//     let levelType = LevelType.getLevelTypeByLevelId(self.levelId)
//     ret.levelType = levelType
//     ret.levelId = self.levelId
//     return ret
// }
StartBuildShipLevelLogic.prototype.start = function (onSuccess, onFail) {
    let self = this
    self.successCallback = onSuccess
    self.failCallback = onFail
    self.startLevel()
}
StartBuildShipLevelLogic.prototype.startReplay = function (replay, id, score) {
    let self = this
    let instance = CreateGameSceneLogic.create(self.levelId, self.initProps)
    instance.setOtherData(self.otherData)
    instance.startReplayGamePlayScene(replay, id, score, () => {
        self.successCallback && self.successCallback()
        self.initLevelLogics()
    })
}
StartBuildShipLevelLogic.prototype.startLevel = function () {
    let self = this
    let context = this
    function success() {
        let instance = CreateGameSceneLogic.create(context.levelId, context.initProps)
        instance.setOtherData(self.otherData)
        function fail(event = {}) {
            Toast.make(curryQuickGetErrorText(event.data), 1, () => {
                let sceneName = cc.director._runningScene.name || cc.director._runningScene._name
                if (sceneName !== "HomeScene") {
                    cc.Director.getInstance().popScene()
                }
                self.failCallback && self.failCallback()
            })
        }
        instance.startGamePlayScene(function (fileList) {
            function success(event) {
                // GoldMatchActivityManager.getInstance().onStartLevel(event.data)
                
                _G.lastStartLevelHttpInfo = {
                    // props : table(),
                    // levelCollectionType : event.data.levelCollectionType,
                    // actPreProp : table(),
                    extraData : self.otherData,
                    buildshipAlreadyStartlevel : true
                }
        

                self.successCallback && self.successCallback()
                context.initLevelLogics()
                instance.createGamePlayScene(fileList)
            }
            // let retrytime = 2
            // function onfail(event) {
            //     // 如果是后端直接返回错误重试
            //     if (event && event.data > 0) {
            //         retrytime = 0
            //     }
            //     if (--retrytime > 0) {
            //         setTimeout(() => {
            //             startLevel()
            //         }, 20);
            //     } else {
            //         fail(event)
            //     }
            // }

            function oncancel(){
                self.failCallback && self.failCallback()
            }
            // let http = GoldMatchStartLevelHttp.new()
            // http.addEventListener(Events.kComplete, success)
            // http.addEventListener(Events.kError, success)
            // http.load(self.levelId)

            //startlevel接口
            // let otherData = self.extraData
            // fail()
            require("clover/logic/userLevel/UserLevelTypeBase").prototype.startLevel.call(null, context.levelId, context.initProps, success, fail, oncancel, self.otherData)

            // success()
        }, fail)
    }
    //使用BuildShipUserLevelType关卡类型
    let levelType = LevelType.getLevelTypeByLevelId(self.levelId)
    let currentLevel = UserLevel.getInstance().levelTypeEnum[levelType].create(self.levelId, self.initProps)
    UserLevel.getInstance().setCurrentLevel(currentLevel)
    currentLevel.startLevel(self.levelId, self.initProps, success )
    // UserLevel.getInstance().startLevel(self.levelId, self.initProps, success, null, null, false)

}
module.exports = StartBuildShipLevelLogic
